import { RequirementDefinitionSharedFileFormValues } from "../../../../types";

import { getMimeTypesLabel } from "./getMimeTypesLabel";

export const getSharedFileSettings = (
  settings: Partial<RequirementDefinitionSharedFileFormValues>
): string[] => {
  const items: string[] = [];

  if (settings.mimeTypes) {
    items.push(`Accepted formats: ${getMimeTypesLabel(settings.mimeTypes)}`);
  }

  if (settings.instructions) {
    items.push(`Instructions: ${settings.instructions}`);
  }

  return items;
};
